import { streakAchievement } from './helpers';

export default streakAchievement(7, 200);
